import { api } from "@/services/api"

import { Contact } from "../hooks/use-chat-store"

export const contactService = {
  async getContact(contactId: string): Promise<Contact> {
    const response = await api.get(`/contacts/${contactId}`)
    return response.data
  },

  async blockContact(
    contactId: string,
    reason: string,
    startHandoff: boolean = true
  ): Promise<Contact> {
    const response = await api.post(`/communication/contacts/${contactId}/block`, {
      reason,
      start_handoff: startHandoff,
    })
    return response.data
  },

  async unblockContact(contactId: string): Promise<Contact> {
    const response = await api.post(`/communication/contacts/${contactId}/unblock`)
    return response.data
  },
}
